import { NgModule, ModuleWithProviders } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//
// Service Providers
//
import { RtiHttpBaseService } from './rti-HttpBaseService';
import { RtiHttpService } from './rti-HttpService';
import { RtiAuthenticationService } from './authentication/rti-authentication.service';
import { RtiTokenInterceptor } from './interceptor/rti-token.interceptor';
import { RtiJsonService } from './common/rti-JsonService';
import { RtiMessageBusService } from './common/rti-MessageBusService';

const RTI_PROVIDERS = [
  RtiHttpBaseService,
  RtiHttpService,
  RtiJsonService,
  RtiMessageBusService,
  RtiAuthenticationService,
  RtiTokenInterceptor
];

@NgModule(
  { imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] }
)
export class RtiHttpServiceModule {
  public static forRoot(): ModuleWithProviders<RtiHttpServiceModule> {
    return {
      ngModule: RtiHttpServiceModule,
      providers: RTI_PROVIDERS
    };
  }
}
